<template>
    <div>
        <MainPage :pageTitle="lbl.detail.title" bgClass="bg-a-gray-efefef">
            <div class="container mx-auto pt-3" v-if="isLoaded">
                <div class="grid grid-cols-1 md:grid-cols-2 gap-4" v-if="campaign != null">
                    <div>
                        <Picture :campaign="campaign"></Picture>
                    </div>
                    <div class="pt-2 pb-20">
                        <DetailInfo :campaign="campaign"></DetailInfo>
                        <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                    </div>
                    <div class="fixed bottom-0 left-0 flex w-full bg-white shadow-lg">
                        <RedeemButton
                                v-if="isShowBtnRedeem"
                                class="w-full px-26 py-3"
                                :detailController="detailController"
                                @clickRedeem="clickRedeem()"
                        ></RedeemButton>
                    </div>
                </div>
            </div>
        </MainPage>
    </div>
</template>
<script>
//helper
import Util from '@/helper/Utility.js';
//component
import MainPage from '@/components/Layout/Page/MainPage.vue';
import DetailInfo from '../component/DetailInfo.vue';
import Picture from '../component/Picture.vue';
import DetailAndCondition from '../component/DetailAndCondition.vue';
import RedeemButton from '../component/RedeemButton.vue';
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from "@/mixin/LocaleMixin.js";
//controller
import { DetailController } from '../controller/DetailController.js';
import { RedeemController } from '../controller/RedeemController.js';
//service
import { CampaignConfigBuilder } from '@/core/Campaign/model/CampaignConfigModel.js';
import { useTracking } from "@/feature/TrackingFeature"

export default {
    name: "Campaign",
    mixins: [ModalMixin, AuthStatusMixin, LocaleMixin],
    components: {
        MainPage,
        DetailInfo,
        Picture,
        DetailAndCondition,
        RedeemButton,
    },
    setup: function() {
        /**@type {import('@/helper/TrackingHelper').TrackingService} */
        const tracking = useTracking()

        return {
            tracking,
        }
    },
    data: function() {
        return {
            isLoaded: false,
            //controller
            detailController: new DetailController(),
            redeemController: new RedeemController(),

            campaign: null,
            isShowBtnRedeem: false

        };
    },
    created: function() {
        this.tracking.screenName('privilege_page_detail')
        this.initialIsFromLanding();
    },
    activated() {
        if (this.isLoaded) {
            this.initialCampaign();
        }

        // called on initial mount
        // and every time it is re-inserted from the cache
    },
    mounted: function(){
        this.modal.loadingModal.show()
    },
    methods: {
        //#region mixin
        /**
         * ฟังก์ชันนี้ถูกเรียก หลังจากตรวจสอบได้แล้วว่า login แล้วหรือยัง
         */
        onAccountInit: function() {
            this.initialCampaign();
        },
        /**
         * ฟังก์ชันนี้ถูกเรียก หลักจาก setup generic model เรียบร้อย
         */
        onSetupModalCompleted: function() {
            this.initialRedeemModal(); //ModalMixin
            this.initialAddressModal(); //ModalMixin
        },
        //#endregion mixin

        //#region initial
        initialCampaign: function () {
            let campaignId = this.$route.params.campaignId;
            this.campaignConfig = new CampaignConfigBuilder()
                .setCampaignId(campaignId)
                .create();

            this.setupDetailController();
        },

        /**
         * Function หลังจากหลับมาจากเว็บ Interface ให้ clear browser history
         */
        initialIsFromLanding: function () {
            let backCount = this.$route.query.back;
            if (Util.isNumber(backCount) && backCount != 0) {
                this.$router.go(backCount);
            }
        },
        //#endregion initial

        //#region setup
        setupDetailController: function() {
            this.modal.loadingModal.show();
            this.detailController.initial(this.campaignConfig).then((campaign) => {
                Util.log("campaign", campaign);
                this.campaign = campaign;

                this.tracking.event("privilege_page_detail", "view_privilege_detail", this.campaign.id + '|' + this.campaign.name, "");

                this.redeemController.initial(this.campaign, this.modal);
                this.setRedeemEvent();
                this.onLoadedCampaign();
            }).catch((err) => {
                this.errorApi(err);
            }).finally(() => {
                this.modal.loadingModal.hide();
            });
        },
        //#endregion setup

        //#region event
        clickRedeem: function() {
            this.tracking.event("privilege_page_detail", "click_redeem_privilege", this.detailController.selectedCampaignId + "|" + this.detailController.campaign.name, "");
            let selectCampaignId = this.detailController.selectedCampaignId;
            let selectedQuantity = this.detailController.selectedQuantity;
            this.redeemController.clickRedeem(selectCampaignId, selectedQuantity);
        },
        setRedeemEvent: function() {
            this.redeemController.onClickRedeem = () => {
                return true;
            };
            this.redeemController.onConfirmRedeem = () => {
                return true;
            };
            this.redeemController.onCancelRedeem = () => {
                return true;
            };
            this.redeemController.onOpenInterface = () => {
                return true;
            };
            this.redeemController.onOpenShipping = () => {
                return true;
            };
            this.redeemController.onSaveShipping = () => {
                return true;
            };
            this.redeemController.onRedeem = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onRedeemSuccess = () => {
                this.initialCampaign();
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onRedeemError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCart = () => {
                this.modal.loadingModal.show();
                return true;
            };
            this.redeemController.onAddToCartSuccess = () => {
                this.modal.loadingModal.hide();
                return true;
            };
            this.redeemController.onAddToCartError = () => {
                this.modal.loadingModal.hide();
                return true;
            };
        },
        //#endregion event

        onLoadedCampaign: function() {
            this.isLoaded = true;
            this.modal.loadingModal.hide()

            this.reloadBtnRedeem()
        },
        clickBack: function() {
            this.$router.back();
        },
        reloadBtnRedeem: function(){
            this.isShowBtnRedeem = false
            this.$nextTick(()=>{
                this.isShowBtnRedeem = true
            })
        }
    },
}
</script>
